import { FC, ReactNode } from "react";
import { NavLink } from "react-router";
import classNames from "classnames";
import styles from "./styles.module.scss";

/** The `SidebarNavSectionItem` properties. */
export interface SidebarNavSectionItemProps {

  /** The id of the card. */
  readonly id?: string;

  /** The sidebar item displayed on this drawer item. */
  readonly path?: string;

  /** The optional test id of the navigation sidebar item. */
  readonly testId?: string;

  /** The optional switch to disable exact path matching. */
  readonly nonExactMatch?: boolean;

  /** The component children. */
  readonly children?: ReactNode;
}

/** The in-context sidebar navigation component. */
export const SidebarNavSectionItem: FC<SidebarNavSectionItemProps> = (props) => {
  const { id, testId, children, path, nonExactMatch = false } = props;

  if (path) {
    return (
      <NavLink
        id={id}
        to={path}
        end={!nonExactMatch}
        data-testid={testId ? `test__${testId}-nav-sidebar-item` : undefined}
        className={({ isActive }) => classNames(styles.SideBarNavItem, "nav-sidebar-item", { "active": isActive })}
      >
        {children}
      </NavLink>
    );
  } else {
    return (
      <div id={id} className={classNames(styles.SideBarNavItem, "nav-sidebar-item")} data-testid={testId ? `test__${testId}-nav-sidebar-item` : undefined}>
        {children}
      </div>
    );
  }
};
